/**
 * Account Completion wrapper.
 * 
 * This element checks if the account is complete and redirects
 * to the account completion page if it's not.
 */

import { FC, useEffect } from "react"
import useAuth from "hooks/useAuth"
import FormLoading from "components/formParts/formLoading";

interface AccountCompletionProps {
    children: React.ReactNode;
    fallbackURL: string;
}

const AccountCompletion: FC<AccountCompletionProps> = ({ children, fallbackURL }) => {

    const {enforceAccountCompletion, accountPublicData} = useAuth()

    useEffect(() => {
        enforceAccountCompletion(fallbackURL)
    }, [accountPublicData, fallbackURL, enforceAccountCompletion])

    if (!accountPublicData) {
        return <FormLoading />
    } else {
        return <>{children}</>
    }
}

export default AccountCompletion


